export default __webpack_public_path__ + "static/media/numeric-icon.2b3ae333.svg";